import React, { useState } from "react";
import parseISO from "date-fns/parseISO";
import subDays from "date-fns/subDays";
import { isAfterDate } from "utils/date-utils";
import clsx from "clsx";

import Typography from "@material-ui/core/Typography";
import CheckIcon from "@material-ui/icons/Check";
import Launch from "@material-ui/icons/Launch";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import HorseListsModal from "components/HorseListsModal";
import WorkoutRequiredDialog from "components/WorkoutRequiredDialog";
import FlashMessage from "components/FlashMessage";
import Link from "components/Link";
import routes from "common/routes";
import ScheduleHeaderPreview from "./ScheduleHeaderPreview";

import useStyles from "./styles";

export interface Props {
  horse: racehorse360.IHorse;
  schedule: racehorse360.IWorkout[];
  successFlashCount: number;
}

const ScheduleHeader = (props: Props) => {
  const { horse, successFlashCount, schedule = [] } = props;
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  const hasVetLists = horse.activeVetListsCount > 0;

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className={classes.header}>
      <Link to={routes.horseDetails.path.replace(":horseId", horse.id)}>
        <Typography
          className={clsx(classes.horseName, {
            [classes.horseNameLinkView]: hasVetLists
          })}
        >
          {horse.name}&nbsp;
          <Typography component={"span"} className={classes.scheduleLength}>
            (
            {
              schedule.filter(d =>
                isAfterDate(parseISO(d.date), subDays(new Date(), 1))
              ).length
            }
            )
          </Typography>
        </Typography>
      </Link>
      {hasVetLists && (
        <HorseListsModal horseId={horse.id} horseName={horse.name} />
      )}
      <ScheduleHeaderPreview
        className={classes.schedulePreview}
        schedule={schedule}
      />
      <FlashMessage startTimestamp={successFlashCount}>
        <Typography className={classes.changesSavedWrapper}>
          <CheckIcon className={classes.changesSavedIcon} /> Changes Saved
        </Typography>
      </FlashMessage>
      <Typography className={classes.detailsLinkWrapper} component={"div"}>
        <Link
          to={`${routes.horseWorkouts.path.replace(":horseId", horse.id)}`}
          className={classes.detailsLink}
        >
          <Typography component={"span"} className={classes.detailsLinkText}>
            Calendar View{" "}
          </Typography>
          <Launch className={classes.detailsLinkIcon} />
        </Link>
      </Typography>

      <WorkoutRequiredDialog
        open={isOpen}
        horseName={horse.name}
        onClose={handleClose}
      />
    </div>
  );
};

export default React.memo(ScheduleHeader);
